// extracted by mini-css-extract-plugin
export default {"title":"Clients_title__JHCBj","list":"Clients_list__hcKGn","logo":"Clients_logo__lFCL1"};